import React from "react";
import "./App.css";
import Main from "./components/Main";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from "./redux/store";
import { decideFavIcon } from "./utils/decideFavIcon";

function App() {
  useEffect(() => {
    const apiPort = 8890;
    // Normally the API is assumed to sit on the same host as the console, on
    // 8890. REACT_APP_API_BASE overrides that whole origin, so a local dev
    // server can be pointed at a deployed backend without editing this file.
    const apiValue =
      process.env.REACT_APP_API_BASE ||
      `${window.location.protocol}//${window.location.hostname}:${apiPort}`;
    localStorage.setItem("api", apiValue);
    localStorage.setItem("meetingObject", JSON.stringify({}));
    decideFavIcon();
  }, []);
  return (
     <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <div className="App">
            <Helmet>
              <script type="text/javascript">
                {`
                (function(c,l,a,r,i,t,y){
                    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "h5crsriwms");
                `}
              </script>
            </Helmet>

            <Main />
            <ToastContainer />
          </div>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
